/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTRepeater } from './repeater';
export type { KTRepeaterConfigInterface, KTRepeaterInterface } from './types';
